import React from "react";
import Card from "react-bootstrap/Card";



function EducationCards(props) {
  return (
    
    <Card className="quote-card-view">
    <Card.Body>
      <blockquote className="blockquote mb-1">
       
        <p style={{ textAlign: "right", fontSize:"33px",paddingRight:"5%",paddingTop:"2%"}}>
          DELHI  TECHNOLOGICAL  UNIVERSITY
          <br />
          <p style={{ textAlign: "right ", fontSize:"25px" }}>
          DELHI, INDIA
          <br />
          INFORMATION TECHNOLOGY
          <br/>
           <span className="purple">2020-2024</span>
          <br />
          CGPA:8.40
          <br />
          </p>
        
        </p>
        
     
      </blockquote>
    </Card.Body>
  </Card>
  );
}
export default EducationCards;
